import { render } from "./Cart.vue?vue&type=template&id=04fc4e70&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-04fc4e70"

export default script